import { getApiClient } from "@punchup/utils";

import { LiveReportLink, LiveReportSales } from "../../models/live-report";

export async function ensureLiveReportAccess(): Promise<void> {
  await getApiClient().post<{ data: { ok: true } }>(
    "/api/v2/user/live-report/token"
  );
}

export async function getLiveReportLinks(): Promise<LiveReportLink[]> {
  return getApiClient()
    .get<{ data: LiveReportLink[] }>("/api/v2/user/live-report/links")
    .then((res) => res.data);
}

export async function getLiveReportLink(uuid: string): Promise<LiveReportLink> {
  return getApiClient()
    .get<{ data: LiveReportLink }>(
      `/api/v2/user/live-report/links/${encodeURIComponent(uuid)}`
    )
    .then((res) => res.data);
}

export async function getLiveReportSales(
  eventId: number | string
): Promise<LiveReportSales> {
  return getApiClient()
    .get<{ data: LiveReportSales }>(
      `/api/v2/user/live-report/events/${encodeURIComponent(String(eventId))}/sales`
    )
    .then((res) => res.data);
}
